<template>
  <div class="col-md-12">
    <div class="col-md-12 box">
      <div class="box__header">
        <span>{{ title }}</span>
        <btn-back v-if="btnBack" :route="routeBtnBack"/>
      </div>
      <div class="box__inputs">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
import BtnDefault from "../buttons/btnDefault.vue";
import BtnBack from "../buttons/btnBack.vue";

export default {
  name: "boxListFilter",
  components: {BtnBack, BtnDefault},
  props: {
    title: "",
    btnBack: false,
    routeBtnBack: '',
  },
};
</script>

<style lang="scss" scoped>
/* Seletor de bloco */
.box {
  background: #ffffff;
  border-radius: 10px !important;
  padding: 20px;

  /* Seletor de elemento */
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e9ec;

    span {
      color: #191919;
      font-weight: 700;
      font-size: 21px;
    }
  }

  &__inputs {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/boxListFilter.vue